import React from "react"
import { MdBusinessCenter } from "react-icons/md"
import { FaQuestion } from "react-icons/fa"
import { TiGroup } from "react-icons/ti"
import { FaBullhorn } from "react-icons/fa"
import { MdDvr } from "react-icons/md"
import { VscFeedback } from "react-icons/vsc"
const Process = () => {
  return (
    <section className="body-font pt-20 pb-10 md:pt-20 md:pb-10 lg:pt-20 lg:pb-20">
      <div className="max-w-screen-md lg:max-w-screen-lg lg:mx-16 xl:mx-auto mx-auto">
        <div className="h-auto text-white rounded-lg px-6 lg:px-0">
          <div className="md:px-10 lg:px-0">
            <h1 className="text-sm md:text-base lg:text-xl text-yellow-500 thin-text tracking-normal">
              PROCESS
            </h1>
            <h2 className="text-white uppercase text-sm md:text-base lg:text-xl light-text mt-2 lg:mt-3 tracking-normal">
              A well-structured process for building your new website.
            </h2>
            <p className="text-xl md:text-2xl text-center font-metropolis font-normal md:font-light lg:text-4xl text-white pt-16 md:pt-24 lg:pt-32">
              We'll go through this process together to make sure that the
              newly-designed website hits the mark.
            </p>
          </div>
          <div class="container pt-16 md:pt-20 lg:pt-24 pb-16 mx-auto flex flex-wrap">
            <div class="flex relative pt-10 pb-20 sm:items-center md:w-3/4 xl:w-4/5 mx-auto">
              <div class="h-full w-6 absolute inset-0 flex items-center justify-center">
                <div class="h-full w-1 bg-process pointer-events-none"></div>
              </div>
              <div class="flex-shrink-0 w-6 h-6 rounded-full mt-10 sm:mt-0 inline-flex items-center justify-center bg-yellow-500 text-white relative z-10 title-font font-medium text-sm"></div>
              <div class="flex-grow md:pl-8 pl-6 flex sm:items-center items-start flex-col sm:flex-row">
                <div class="flex-shrink-0 w-24 h-24 shadow-md bg-process text-yellow-500 rounded-3xl inline-flex items-center justify-center">
                  <MdBusinessCenter className="w-10 h-10" />
                </div>
                <div class="flex-grow sm:pl-6 mt-6 sm:mt-0">
                  <h2 class="body-text text-white text-2xl lg:text-3xl">
                    Business
                  </h2>
                  <p class="text-lg md:text-base pt-1 text-white lg:text-xl thin-text leading-snug">
                    I need to have an in-depth idea of what you exactly do.
                  </p>
                </div>
              </div>
            </div>
            <div class="flex relative pb-20 sm:items-center mx-auto md:w-3/4 xl:w-4/5 ">
              <div class="h-full w-6 absolute inset-0 flex items-center justify-center">
                <div class="h-full w-1 bg-process pointer-events-none"></div>
              </div>
              <div class="flex-shrink-0 w-6 h-6 rounded-full mt-10 sm:mt-0 inline-flex items-center justify-center bg-yellow-500 text-white relative z-10 title-font font-medium text-sm"></div>
              <div class="flex-grow md:pl-8 pl-6 flex sm:items-center items-start flex-col sm:flex-row">
                <div class="flex-shrink-0 w-24 h-24 shadow-md bg-process text-yellow-500 rounded-3xl inline-flex items-center justify-center">
                  <FaQuestion className="w-10 h-10" />
                </div>
                <div class="flex-grow sm:pl-6 mt-6 sm:mt-0">
                  <h2 class="body-text text-white text-2xl pt-2 lg:text-3xl">
                    Whys
                  </h2>
                  <p class="text-lg font-light text-white pt-2 md:pt-1 lg:text-xl thin-text leading-snug">
                    “Whys” will help me to get a better understanding of your
                    problem.
                  </p>
                </div>
              </div>
            </div>
            <div class="flex relative pb-20 sm:items-center mx-auto md:w-3/4 xl:w-4/5 ">
              <div class="h-full w-6 absolute inset-0 flex items-center justify-center">
                <div class="h-full w-1 bg-process pointer-events-none"></div>
              </div>
              <div class="flex-shrink-0 w-6 h-6 rounded-full mt-10 sm:mt-0 inline-flex items-center justify-center bg-yellow-500 text-white relative z-10 title-font font-medium text-sm"></div>
              <div class="flex-grow md:pl-8 pl-6 flex sm:items-center items-start flex-col sm:flex-row">
                <div class="flex-shrink-0 w-24 h-24 shadow-md text-yellow-500 rounded-3xl inline-flex items-center justify-center bg-process">
                  <TiGroup className="w-10 h-10" />
                </div>
                <div class="flex-grow sm:pl-6 mt-6 sm:mt-0">
                  <h2 class="body-text text-white text-2xl pt-2 lg:text-3xl">
                    Target Audience
                  </h2>
                  <p class="text-lg font-light text-white pt-2 md:pt-1 lg:text-xl thin-text leading-snug">
                    Identifying types of customers who might be interested in
                    the website.
                  </p>
                </div>
              </div>
            </div>
            <div class="flex relative pb-20 sm:items-center mx-auto md:w-3/4 xl:w-4/5 ">
              <div class="h-full w-6 absolute inset-0 flex items-center justify-center">
                <div class="h-full w-1 bg-process pointer-events-none"></div>
              </div>
              <div class="flex-shrink-0 w-6 h-6 rounded-full mt-10 sm:mt-0 inline-flex items-center justify-center bg-yellow-500 text-white relative z-10 title-font font-medium text-sm"></div>
              <div class="flex-grow md:pl-8 pl-6 flex sm:items-center items-start flex-col sm:flex-row">
                <div class="flex-shrink-0 w-24 h-24 shadow-md text-yellow-500 rounded-3xl inline-flex items-center justify-center bg-process">
                  <FaBullhorn className="w-10 h-10" />
                </div>
                <div class="flex-grow sm:pl-6 mt-6 sm:mt-0">
                  <h2 class="body-text text-white text-2xl pt-2 lg:text-3xl">
                    CTAs
                  </h2>
                  <p class="text-lg font-light text-white pt-2 md:pt-1 lg:text-xl thin-text leading-snug">
                    Getting the target audience do what you want through Call To
                    Actions.
                  </p>
                </div>
              </div>
            </div>
            <div class="flex relative pb-20 sm:items-center mx-auto md:w-3/4 xl:w-4/5 ">
              <div class="h-full w-6 absolute inset-0 flex items-center justify-center">
                <div class="h-full w-1 bg-process pointer-events-none"></div>
              </div>
              <div class="flex-shrink-0 w-6 h-6 rounded-full mt-10 sm:mt-0 inline-flex items-center justify-center bg-yellow-500 text-white relative z-10 title-font font-medium text-sm"></div>
              <div class="flex-grow md:pl-8 pl-6 flex sm:items-center items-start flex-col sm:flex-row">
                <div class="flex-shrink-0 w-24 h-24 shadow-md text-yellow-500 rounded-3xl inline-flex items-center justify-center bg-process">
                  <MdDvr className="w-10 h-10" />
                </div>
                <div class="flex-grow sm:pl-6 mt-6 sm:mt-0">
                  <h2 class="body-text text-white text-2xl pt-2 lg:text-3xl">
                    Design
                  </h2>
                  <p class="text-lg font-light text-white pt-2 md:pt-1 lg:text-xl thin-text leading-snug">
                    The overall design of website should be consistent &
                    irresistible.
                  </p>
                </div>
              </div>
            </div>
            <div class="flex relative pb-10 sm:items-center mx-auto md:w-3/4 xl:w-4/5 ">
              <div class="h-full w-6 absolute inset-0 flex items-center justify-center">
                <div class="h-full w-1 bg-process pointer-events-none"></div>
              </div>
              <div class="flex-shrink-0 w-6 h-6 rounded-full mt-10 sm:mt-0 inline-flex items-center justify-center bg-yellow-500 text-white relative z-10 title-font font-medium text-sm"></div>
              <div class="flex-grow md:pl-8 pl-6 flex sm:items-center items-start flex-col sm:flex-row">
                <div class="flex-shrink-0 w-24 h-24 shadow-md text-yellow-500 rounded-3xl inline-flex items-center justify-center bg-process">
                  <VscFeedback className="w-10 h-10" />
                </div>
                <div class="flex-grow sm:pl-6 mt-6 sm:mt-0">
                  <h2 class="body-text text-white text-2xl pt-2 lg:text-3xl">
                    Feedback
                  </h2>
                  <p class="text-lg font-light text-white pt-2 md:pt-1 lg:text-xl thin-text leading-snug">
                    Review & let me know if there are any colors and features to
                    avoid.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Process
